import { apiFetch } from "./api";

export interface MeResponse {
  userId: string;
  email: string;
  displayName: string;
  employeeId: number | null;
  roles: string[];
  permissions: string[];
  mfaEnabled: boolean;
  mfaRequired: boolean;
  defaultRoute: string;
  featureFlags: Record<string, boolean>;
}

export const fetchMe = (): Promise<MeResponse> => apiFetch<MeResponse>("/api/me");
